import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import {
  FeatureFlagKeys,
  ISetting
} from '@shared/interfaces/setting.interface';
import { SessionStorage } from 'ngx-webstorage';

@Directive({
    selector: '[appFeatureFlag]',
    standalone: false
})
export class FeatureFlagDirective implements OnInit {
  @SessionStorage() public settings: ISetting;

  private hasView = false;
  private featureNames: FeatureFlagKeys[] = [];

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef
  ) {}

  @Input() set appFeatureFlag(featureNames: FeatureFlagKeys[]) {
    this.featureNames = featureNames || [];
    this.updateView();
  }

  ngOnInit() {
    this.updateView();
  }

  private updateView() {
    if (!this.settings || !Array.isArray(this.featureNames)) {
      console.warn('Settings or featureNames are not initialized correctly.');
      return;
    }

    const allFeaturesEnabled = this.featureNames.every((feature) =>
      this.settings.hasFeatureFlag(feature)
    );

    if (allFeaturesEnabled && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!allFeaturesEnabled && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
